import { Award } from "lucide-react";
import { PerformanceReviewRoute } from "./routes/PerformanceReviewRoute";
import { PerformanceReviewConfigRoute } from "./routes/PerformanceReviewConfigRoute";

export const PERF_REVIEW_ROUTES = {
  performanceReviews: {
    key: "performance-reviews",
    path: "/performance-reviews",
    title: "Performance Reviews",
    icon: <Award size={17} />,
    element: <PerformanceReviewRoute />
  },
  performanceReviewsConfig: {
    key: "performance-reviews-config",
    path: "/performance-reviews/config",
    title: "Configuration",
    element: <PerformanceReviewConfigRoute />
  }
};
